const extractAnswersFromSession = (uuid) => {
  const localAnswersKey = `${uuid}-localAnswers`;
  return JSON.parse(window.sessionStorage.getItem(localAnswersKey) || '{}');
};
export default extractAnswersFromSession;